<div class="row intro">
    <div class="intro-sub">
        <div class="row website-name">About Us</div>
        <div class="row">
            <div class="col-md-4 col-md-offset-4 break-line"></div>
        </div>

    </div>
</div>

<div class="row" id="Our Team" style="text-align: center; align-content: center; height:100vh">
    <div class="col-md-12 section-heading">
        <h2>Meet Our Team</h2>
    </div>
    <div class="col-md-12" style="height: 15vh;">
        <hr style="width: 260px; border: 2px solid black;">
    </div>
    <div class="col-md-12" style="display: flex; justify-content: center;" >
            <div style="width: 20%;">
                <span class="material-icons md-48">face</span>
                <!-- <img class="card-img-top" src="..." alt="Card image cap"> -->
                <div class="card-body">
                    <h5 class="card-title">Viekko</h5>
                    <!-- <p class="card-text">Software Developer</p> -->
                </div>
            </div>
            <div style="width: 20%;">
                <span class="material-icons md-48">face</span>
                <!-- <img class="card-img-top" src="..." alt="Card image cap"> -->
                <div class="card-body">
                    <h5 class="card-title">Sahil Kharya</h5>
                    <!-- <p class="card-text">Software Developer</p> -->
                </div>
            </div>
            <div style="width: 20%;">
                <span class="material-icons md-48">face</span>
                <!-- <img class="card-img-top" src="..." alt="Card image cap"> -->
                <div class="card-body">
                    <h5 class="card-title">Lee May</h5>
                    <!-- <p class="card-text">Software Developer</p> -->
                </div>
            </div>
            <div style="width: 20%;">
                <span class="material-icons md-48">face</span>
                <!-- <img class="card-img-top" src="..." alt="Card image cap"> -->
                <div class="card-body">
                     <h5 class="card-title">Junko Nagao</h5>
                   <!-- <p class="card-text">Software Developer</p> -->
                </div>
            </div>
            <div style="width: 20%;">
                <span class="material-icons md-48">face</span>
                <!-- <img class="card-img-top" src="..." alt="Card image cap"> -->
                <div class="card-body">
                     <h5 class="card-title">Sagar Jethi</h5>
                  <!--  <p class="card-text">Software Developer</p> -->
                </div>
            </div>
    </div>

</div>
<footer>
    <img style="width: 100%;" src="../../../assets/scaling.png">
</footer>